const zh = {
   9000001: " 2023聖誕杯",
   9000002: "SuperEx合約錦標賽",
   9000003: "贏取30,000USDT競賽獎金",
   9000004: "参赛人数",
   9000005: "已解锁奖池（USDT）",
   9000006: "交易量排名资格赛",
   9000007: "盈利率排名資格賽",
   9000008: "盈利額排名資格賽",
   9000009: `交易量排名赛，解锁最高 <span style="color: #ffc72b;">20,000</span> USDT 奖金池`,
   9000010: "根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高20,000USDT獎金池",
   9000011: "奖池金额",
   9000012: "活动期间每天10:00（UTC）更新",
   9000013: "獎勵預估",
   9000014: "期間纍計期貨交易金額",
   9000015: "奖励规则",
   9000016: "根据参赛人数解锁对应奖池，参赛人数越多解锁奖池越大，最高20,000U奖金池",
   9000017: "奖池金额（USDT）",
   9000018: "活动盈利率排名",
   9000019: "报名",
   9000020: "活动盈利额排名",
   9000021: "已结束",
   9000022: `盈利率排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
   9000023: `盈利額排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
   9000024: "累计合約盈利率",
   9000025: "纍計合约盈利金額",
   9000026: "未开始",
   9000027: "參賽用戶盈利額排名前50名獲得獎勵，可參考交易排名獎勵規則獲取贈金獎勵",
   9000028: "參賽用戶盈利率排名前50名可獲得獎勵，可參考交易排名獎勵規則獲取獎勵",
   9000029: "活動交易額排名",
   9000030: "",

   //交易合约积分
   9100001: '攒积分',
   9100002: '得空投',
   9100003: '兑奖励',
   9100004: '积分余额',
   9100005: '明细',
   9100006: '签到积分',
   9100007: '交易积分',
   9100008: '邀请积分',
   9100009: '奖励积分',
   9100010: '幸运抽奖',
   9100011: '获取积分',
   9100012: '积分规则',
   9100013: '积分明细',
   9100014: '您需要报名才能参与此活动,点击即可参与',
   9100015: '已连续交易 {day} 天并获得 {num} 积分',
   9100016: '今日已得 {num} 积分',
   9100017: '积分奖池',
   9100018: '每次抽奖消耗 {point} 积分，每天最多抽 {num} 次',
   9100019: '今日抽奖次数',
   9100020: '用户',
   9100021: '积分',
   9100022: '积分余额不足',
   9100023: '积分余额不足，请获取积分后再参与抽奖',
   9100024: '抽奖次数已达上限',
   9100025: '今日抽奖次数已达上限，请明日再试。',
   9100026: '如何获得积分',
   9100027: '报名参与合约交易获积分活动，才能获得积分',
   9100028: '参与报名成功',
   9100029: '您已报名参与合约交易获积分活动，去交易获得更多积分吧(将不再享受返佣返现奖励）',
   9100030: '取消报名后，将不再获得积分，您确定要取消报名吗？',
   9100031: '交易积分活动中心',
   9100032: '获取积分',
   9100033: '您需要报名才能参与此活动,点击即可参与',
   9100034: '连续参与合约积分即可获得积分',
   9100035: '用户在合约市场产生的所有交易行为即可获取积分',
   9100036: '排行榜积分',
   9100037: '每日交易排行榜前五给与额外的奖励积分',
   9100038: '被邀请人产生积分，邀请人可获得奖励积分',
   9100039: '{guy} 已经中奖<span style="color:#D9A31A"> {num} 积分</span>',
   9100040: '立即抽奖',
   9100041: '恭喜您获得了',
   9100042: '全部类型',
   9100043: '留在此页',
   9100044: '参与报名',
   9100045: '继续交易',
   9100046: '暂无正在进行的活动，敬请期待...',
   9100047: '兑SCS代币',
   9100048: '',
   9100049: '',

   9100050: '日期',
   9100051: '起始时间',
   9100052: '结束时间',
   9100053: '到',
   9100054: '类型',

   9100055: '可获积分=交易额*1%（难度随着平台总交易量的上升会进一步调整）',
   9100056: '例如:用户使用保证金100USDT*100X=10000U的仓位',
   9100057: '那么只需要100USDT的保证金即可获得100积分',
   9100058: '交易积分是获取平台代币SCS的唯一渠道',
   9100059: '额外奖励积分=当日积分总额*名次奖励比例',
   9100060: '名次',
   9100061: '第一名',
   9100062: '第二名',
   9100063: '第三名',
   9100064: '第四名',
   9100065: '第五名',
   9100066: '被邀请人产生积分，邀请人可获得奖励积分',
   9100067: '等级系数',
   9100068: '计算公式：获得推广积分= 被邀请人获得积分 * 等级系数',
   9100069: '等级系数会根据实际情况进行调整',
   9100070: `例如：用户B参与积分活动，其邀请人为用户A，且用户A邀请数量等级已达到Level3，用户B累计获得积分=360,000；`,
   9100071: '那么用户A累计可获的推广积分=360000* 30%=108,000',
   9100072: '奖励系数',
   9100073: '1个交易用户',
   9100074: '交易量达到500W',
   9100075: '交易量达到2000W',

   9100076: '划转',

   //热币
   9100080: '距离活动结束',
   9100081: '点击「报名参加」赢大奖',
   9100082: '查看规则',
   9100083: '报名参加',
   9100084: '活动',
   9100088: '去交易',
   9100089: '去充值',
   9100090: '您已报名该活动',
   
   9100091: '本次活动已结束，敬请期待下一次活动！',
   9100092: '活动未开始，敬请期待',
   9100093: '',
   9100094: '',

   //自由区二维码分享页面
   9100095: '自由区上币，开启财富自由',
   9100096: '打开APP',
   9100097: '',
   9100098: '',
}
export default zh



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/zh.js